import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import 'rxjs/add/operator/map';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CheckSocorristaService {
  private data = null;
	private url = environment.serviceApi;

  constructor(public http: Http) { }
  
  getChecksSocorrista(ordem=null) {
		return new Promise((resolve, reject) => {
			this.http.get(this.url + '/checksocorrista' + (ordem? '/ordem/' + ordem : ''))
			.map(res => res.json())
			.subscribe(data => {
				this.data = data;
				resolve(this.data);
			},
			err => {
				reject(err);
			});
		});
  }
  
	getCheckSocorrista(id) {
		return new Promise((resolve, reject) => {
			this.http.get(this.url + '/checksocorrista/' + id)
			.map(res => res.json())
			.subscribe(data => {
				this.data = data;
				resolve(this.data);
			},
			err => {
				reject(err);
			});
		});
  }
  
	getCheckSocorristaByUnidade(unidade_id) {
		return new Promise((resolve, reject) => {
			this.http.get(this.url + '/checksocorrista/unidade/' + unidade_id)
			.map(res => res.json())
			.subscribe(data => {
				this.data = data;
				resolve(this.data);
			},
			err => {
				reject(err);
			});
		});
  }
  
	getCheckSocorristaByUsuario(usuario_id) {
		return new Promise((resolve, reject) => {
			this.http.get(this.url + '/checksocorrista/usuario/' + usuario_id)
			.map(res => res.json())
			.subscribe(data => {
				this.data = data;
				resolve(this.data);
			},
			err => {
				reject(err);
			});
		});
	}

	criaCheckSocorrista(data) {
		return new Promise((resolve, reject) => {
			this.http.post(this.url + '/checksocorrista', {
        usuario_id:                                     data.usuario_id,
        check_socorrista_data:                          data.check_socorrista_data,
        check_socorrista_turno:                         data.check_socorrista_turno,
        cliente_id:                                     data.cliente_id,
        unidade_id:                                     data.unidade_id,
        profissional_id:                                data.profissional_id,
        veiculo_id:                                     data.veiculo_id,
        check_socorrista_quilometragem:                 data.check_socorrista_quilometragem,
        check_socorrista_documentacao_flag:             data.check_socorrista_documentacao_flag,
        check_socorrista_documentacao_obs:              data.check_socorrista_documentacao_obs,
        check_socorrista_cartao_abastecimento_flag:     data.check_socorrista_cartao_abastecimento_flag,
        check_socorrista_cartao_abastecimento_obs:      data.check_socorrista_cartao_abastecimento_obs,
        check_socorrista_iluminacao_flag:               data.check_socorrista_iluminacao_flag,
        check_socorrista_iluminacao_obs:                data.check_socorrista_iluminacao_obs,
        check_socorrista_sinais_sonoros_flag:           data.check_socorrista_sinais_sonoros_flag,
        check_socorrista_sinais_sonoros_obs:            data.check_socorrista_sinais_sonoros_obs,
        check_socorrista_pneus_flag:                    data.check_socorrista_pneus_flag,
        check_socorrista_pneus_obs:                     data.check_socorrista_pneus_obs,
        check_socorrista_fluido_freio_flag:             data.check_socorrista_fluido_freio_flag,
        check_socorrista_fluido_freio_obs:              data.check_socorrista_fluido_freio_obs,
        check_socorrista_oleo_motor_flag:               data.check_socorrista_oleo_motor_flag,
        check_socorrista_oleo_motor_data_troca:         data.check_socorrista_oleo_motor_data_troca,
        check_socorrista_oleo_hidraulico_flag:          data.check_socorrista_oleo_hidraulico_flag,
        check_socorrista_oleo_hidraulico_obs:           data.check_socorrista_oleo_hidraulico_obs,
        check_socorrista_unidade_limpa_flag:            data.check_socorrista_unidade_limpa_flag,
        check_socorrista_unidade_limpa_obs:             data.check_socorrista_unidade_limpa_obs,
        check_socorrista_combustivel_flag:              data.check_socorrista_combustivel_flag,
        check_socorrista_marca_retratil_completa_flag:  data.check_socorrista_marca_retratil_completa_flag,
        check_socorrista_marca_retratil_completa_obs:   data.check_socorrista_marca_retratil_completa_obs,
        check_socorrista_prancha_longa_completa_flag:   data.check_socorrista_prancha_longa_completa_flag,
        check_socorrista_prancha_longa_completa_obs:    data.check_socorrista_prancha_longa_completa_obs,
        check_socorrista_torpedo_oxigenio_reserva_flag: data.check_socorrista_torpedo_oxigenio_reserva_flag,
        check_socorrista_torpedo_oxigenio_reserva_obs:  data.check_socorrista_torpedo_oxigenio_reserva_obs,
        check_socorrista_chave_o2_flag:                 data.check_socorrista_chave_o2_flag,
        check_socorrista_chave_o2_obs:                  data.check_socorrista_chave_o2_obs,
        check_socorrista_inversor_flag:                 data.check_socorrista_inversor_flag,
        check_socorrista_radio_ht_flag:                 data.check_socorrista_radio_ht_flag,
        check_socorrista_celular_carregador_flag:       data.check_socorrista_celular_carregador_flag,
        check_socorrista_macaco_flag:                   data.check_socorrista_macaco_flag,
        check_socorrista_triangulo_flag:                data.check_socorrista_triangulo_flag,
        check_socorrista_chave_roda_flag:               data.check_socorrista_chave_roda_flag,
        check_socorrista_socorro_flag:                  data.check_socorrista_socorro_flag,
        check_socorrista_lanterna_flag:                 data.check_socorrista_lanterna_flag,
        check_socorrista_alicate_8_flag:                data.check_socorrista_alicate_8_flag,
        check_socorrista_chave_fenda_1_4_flag:          data.check_socorrista_chave_fenda_1_4_flag,
        check_socorrista_chave_fenda_5_16_flag:         data.check_socorrista_chave_fenda_5_16_flag,
        check_socorrista_martelo_pena_flag:             data.check_socorrista_martelo_pena_flag,
        check_socorrista_jogo_chave_boca_fixa_flag:     data.check_socorrista_jogo_chave_boca_fixa_flag,
        check_socorrista_jogo_chave_estrela_flag:       data.check_socorrista_jogo_chave_estrela_flag,
        check_socorrista_lima_flag:                     data.check_socorrista_lima_flag,
        check_socorrista_pe_de_cabra_flag:              data.check_socorrista_pe_de_cabra_flag,
        check_socorrista_talhadeira_flag:               data.check_socorrista_talhadeira_flag,
        check_socorrista_cabo_energia_flag:             data.check_socorrista_cabo_energia_flag,
        check_socorrista_ar_comprimido_flag:            data.check_socorrista_ar_comprimido_flag,
        check_socorrista_ar_comprimido_obs:             data.check_socorrista_ar_comprimido_obs,
        check_socorrista_status:                        data.check_socorrista_status,
        check_socorrista_justificativa:                 data.check_socorrista_justificativa,
        check_socorrista_registro:                      data.check_socorrista_registro
			})
			.map(res => res.json())
			.subscribe(data => {
				this.data = data;
				resolve(this.data);
			},
			err => {
				reject(err);
			});
		});
	}

	editaCheckSocorrista(data) {
		return new Promise((resolve, reject) => {
			this.http.put(this.url + '/checksocorrista/' + data.check_socorrista_id, {
				usuario_id:                                     data.usuario_id,
        check_socorrista_data:                          data.check_socorrista_data,
        check_socorrista_turno:                         data.check_socorrista_turno,
        cliente_id:                                     data.cliente_id,
        unidade_id:                                     data.unidade_id,
        profissional_id:                                data.profissional_id,
        veiculo_id:                                     data.veiculo_id,
        check_socorrista_quilometragem:                 data.check_socorrista_quilometragem,
        check_socorrista_documentacao_flag:             data.check_socorrista_documentacao_flag,
        check_socorrista_documentacao_obs:              data.check_socorrista_documentacao_obs,
        check_socorrista_cartao_abastecimento_flag:     data.check_socorrista_cartao_abastecimento_flag,
        check_socorrista_cartao_abastecimento_obs:      data.check_socorrista_cartao_abastecimento_obs,
        check_socorrista_iluminacao_flag:               data.check_socorrista_iluminacao_flag,
        check_socorrista_iluminacao_obs:                data.check_socorrista_iluminacao_obs,
        check_socorrista_sinais_sonoros_flag:           data.check_socorrista_sinais_sonoros_flag,
        check_socorrista_sinais_sonoros_obs:            data.check_socorrista_sinais_sonoros_obs,
        check_socorrista_pneus_flag:                    data.check_socorrista_pneus_flag,
        check_socorrista_pneus_obs:                     data.check_socorrista_pneus_obs,
        check_socorrista_fluido_freio_flag:             data.check_socorrista_fluido_freio_flag,
        check_socorrista_fluido_freio_obs:              data.check_socorrista_fluido_freio_obs,
        check_socorrista_oleo_motor_flag:               data.check_socorrista_oleo_motor_flag,
        check_socorrista_oleo_motor_data_troca:         data.check_socorrista_oleo_motor_data_troca,
        check_socorrista_oleo_hidraulico_flag:          data.check_socorrista_oleo_hidraulico_flag,
        check_socorrista_oleo_hidraulico_obs:           data.check_socorrista_oleo_hidraulico_obs,
        check_socorrista_unidade_limpa_flag:            data.check_socorrista_unidade_limpa_flag,
        check_socorrista_unidade_limpa_obs:             data.check_socorrista_unidade_limpa_obs,
        check_socorrista_combustivel_flag:              data.check_socorrista_combustivel_flag,
        check_socorrista_marca_retratil_completa_flag:  data.check_socorrista_marca_retratil_completa_flag,
        check_socorrista_marca_retratil_completa_obs:   data.check_socorrista_marca_retratil_completa_obs,
        check_socorrista_prancha_longa_completa_flag:   data.check_socorrista_prancha_longa_completa_flag,
        check_socorrista_prancha_longa_completa_obs:    data.check_socorrista_prancha_longa_completa_obs,
        check_socorrista_torpedo_oxigenio_reserva_flag: data.check_socorrista_torpedo_oxigenio_reserva_flag,
        check_socorrista_torpedo_oxigenio_reserva_obs:  data.check_socorrista_torpedo_oxigenio_reserva_obs,
        check_socorrista_chave_o2_flag:                 data.check_socorrista_chave_o2_flag,
        check_socorrista_chave_o2_obs:                  data.check_socorrista_chave_o2_obs,
        check_socorrista_inversor_flag:                 data.check_socorrista_inversor_flag,
        check_socorrista_radio_ht_flag:                 data.check_socorrista_radio_ht_flag,
        check_socorrista_celular_carregador_flag:       data.check_socorrista_celular_carregador_flag,
        check_socorrista_macaco_flag:                   data.check_socorrista_macaco_flag,
        check_socorrista_triangulo_flag:                data.check_socorrista_triangulo_flag,
        check_socorrista_chave_roda_flag:               data.check_socorrista_chave_roda_flag,
        check_socorrista_socorro_flag:                  data.check_socorrista_socorro_flag,
        check_socorrista_lanterna_flag:                 data.check_socorrista_lanterna_flag,
        check_socorrista_alicate_8_flag:                data.check_socorrista_alicate_8_flag,
        check_socorrista_chave_fenda_1_4_flag:          data.check_socorrista_chave_fenda_1_4_flag,
        check_socorrista_chave_fenda_5_16_flag:         data.check_socorrista_chave_fenda_5_16_flag,
        check_socorrista_martelo_pena_flag:             data.check_socorrista_martelo_pena_flag,
        check_socorrista_jogo_chave_boca_fixa_flag:     data.check_socorrista_jogo_chave_boca_fixa_flag,
        check_socorrista_jogo_chave_estrela_flag:       data.check_socorrista_jogo_chave_estrela_flag,
        check_socorrista_lima_flag:                     data.check_socorrista_lima_flag,
        check_socorrista_pe_de_cabra_flag:              data.check_socorrista_pe_de_cabra_flag,
        check_socorrista_talhadeira_flag:               data.check_socorrista_talhadeira_flag,
        check_socorrista_cabo_energia_flag:             data.check_socorrista_cabo_energia_flag,
        check_socorrista_ar_comprimido_flag:            data.check_socorrista_ar_comprimido_flag,
        check_socorrista_ar_comprimido_obs:             data.check_socorrista_ar_comprimido_obs,
        check_socorrista_justificativa:                 data.check_socorrista_justificativa,
        check_socorrista_status:                        data.check_socorrista_status
			})
			.map(res => res.json())
			.subscribe(data => {
				this.data = data;
				resolve(this.data);
			},
			err => {
				reject(err);
			});
		});
	}

	apagaCheckSocorrista(id) {
		return new Promise((resolve, reject) => {
			this.http.delete(this.url + '/checksocorrista/' + id)
			.map(res => res.json())
			.subscribe(data => {
				this.data = data;
				resolve(this.data);
			},
			err => {
				reject(err);
			});
		});
  }
	apagaCheckSocorristaAdmin(id) {
		return new Promise((resolve, reject) => {
			this.http.delete(this.url + '/checksocorrista/admin/' + id)
			.map(res => res.json())
			.subscribe(data => {
				this.data = data;
				resolve(this.data);
			},
			err => {
				reject(err);
			});
		});
  }
}
